import request from '@/api/request';
import type { components } from '@/api/API';

export const adminUserList = (body: components['schemas']['UserListResponse']) =>
  request.adminUser.get<string>(body);

export const adminPassword = (body: components['schemas']['ChangePasswordRequest']) =>
  request.adminPassword.post<string>(body);

export const adminAddUser = (body: components['schemas']['UserRegisterRequest']) =>
  request.adminUser.post<string>(body);

export const adminDeleteUser = (body: {
  phone: string;
  username: string;
  password: string;
  role: 'SUPER_ADMIN' | 'ADMIN' | 'OFFICER' | 'REPORTER';
  email: string;
  name: string;
  centers?: string[];
}) => request.adminUser$.delete<string>(body);

export const adminPutUser = (
  id: string,
  body: {
    phone: string;
    username: string;
    password: string;
    role: 'SUPER_ADMIN' | 'ADMIN' | 'OFFICER' | 'REPORTER';
    email: string;
    name: string;
    centers?: string[];
  },
) => request.adminUser$.patch<string>(id, body);

export const userMigrateApi = (body: { fromUserId: number; toUserId: number }) =>
  request.adminUserMigrate.post<string>(body);

export const adminGetAuditApi = (body: {
  size: number;
  centerCode: string | undefined;
  page: number;
  type: string;
}) => request.audit.get<string>(body);

export const adminReviewInfo = (body: string) => request.audit$.get<string>(body);

export const adminReviewPass = (body: { verify: string }) => request.audit.patch<string>(body);

export const adminGetReviewInfo = (body: string) => request.standard$.get<string>(body);

export const adminGetHospitalCode = (body?: string) => request.commonCenter.get<string>(body);

export const adminPostHospitalCode = (body: {
  code: string | undefined;
  name: string | undefined;
}) => request.commonCenter.post<string>(body);
